// https://getbootstrap.com/docs/5.0/forms/select/

import { is } from '@common/is/is'
import DOM from '@common/DOM/DOM'

import type { IChildrenProps } from '../definitions'

interface IProps extends IChildrenProps {
  readonly id?: string
  readonly name?: string
  readonly size?: 'sm' | 'lg'
  readonly multiple?: boolean
  readonly value?: string | number | undefined | null
  readonly onChange?: TEventCallback | undefined
  readonly isDisabled?: boolean
  readonly isValid?: boolean | undefined
  readonly shouldValidate?: boolean
  readonly className?: string
}

/**
 * Egy bootstrap-alapú select komponens.
 * @param props - JSX props {@link IProps}.
 */
export default function Select (props: IProps): HTMLSelectElement {
  let validateClass: 'is-valid' | 'is-invalid' | '' = ''

  if (props.shouldValidate) {
    validateClass = is.empty((props?.value ?? '').toString().trim()) ? 'is-invalid' : 'is-valid'
  }

  /* eslint-disable custom/no-nested-ternary -- Legacy. */
  validateClass = is.boolean(props.isValid)
    ? props.isValid
      ? 'is-valid'
      : 'is-invalid'
    : validateClass
  /* eslint-enable custom/no-nested-ternary */

  const cn: readonly string[] = [
    'form-select',
    validateClass,
    props.className ?? ''
  ]

  const s: HTMLSelectElement = <select className={ cn }>{ props.children }</select>

  if (props.id) {
    s.id = props.id
  }

  if (props.name) {
    s.name = props.name
  }

  if (props.isDisabled) {
    s.disabled = true
  }

  if (props.size) {
    s.classList.add(`form-select-${ props.size }`)
  }

  if (props.multiple) {
    s.setAttribute('multiple', '')
  }

  if (is.nonNullable(props.value)) {
    DOM.setValue(s, props.value)
  }

  if (props.onChange) {
    s.addEventListener('change', props.onChange)
  }

  return s
}
